import Vue from 'vue'
import autofocus from './autofocus'
import skeleton from './skeleton'
import mask from './mask'
import tooltip from './tooltip'

Vue.directive('autofocus', autofocus)
Vue.directive('skeleton', skeleton)
Vue.directive('mask', mask)
Vue.directive('tooltip', tooltip)
